import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { ProfilComponent } from './profil/profil.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { ConfirmationAccountComponent } from './confirmation-account/confirmation-account.component';
import { SigninComponent } from './signin/signin.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SignupComponent } from './signup/signup.component';
export const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'inscription', component: SignupComponent
            },
            {
                path: 'connexion', component: SigninComponent
            },
            {
                path: 'profil', component: ProfilComponent
            },
            {
                path: 'confirme/user/:user/key/:key', component: ConfirmationAccountComponent
            },
            {
                path: 'recuperation/mdp', component: ForgetpasswordComponent
            }
        ]
    },
];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        FormsModule,
        CommonComponentsModule,
        CommonModule
    ],
    declarations: [
        SignupComponent,
        SigninComponent,
        ConfirmationAccountComponent,
        ForgetpasswordComponent,
        ProfilComponent
    ],
    exports: [
        
    ]
})
export class AuthentificationModule {

}
